<template>
  <div class="content">
    <div class="login-wrapper">
      <div class="login">
        <!--<h5 class="text-center">Park Ave</h5>-->
        <!--<h5 class="text-center">Personal Health Record</h5>-->
        <!-- <form @submit.prevent="handleRegistration" class="form" ref="formContainer">-->
        <div class="setup-header"><span class="setup-span">Account Setup</span></div>
        <form @submit.prevent="CreateNewAccount()" class="form" id="formContainer">
          <!-- <div class="b-form-group form-groupx row" role="group"> -->
          <div class="mb-2">
            <!--Keyon Adding New Form Here-->
            <!-- <div class="col-sm-12 col-md-12 col-lg-12 new-accountForm"> -->
            <!--Accnt Section-->
            <!-- <div id="AccntSection" class="col-sm-12 col-md-12 col-lg-12 col-xl-12"> -->
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  id="emr_type"
                  class="form-control"
                  v-model="form.accountType"
                  required
                >
                  <option value="">Select account type</option>
                  <option v-if="!this.isLoggedIn" value="Business">Business</option>
                  <option v-if="this.isLoggedIn" value="Patient">Patient</option>
                  <!-- <option value="Independent Contractor">Independent Contractor</option>
                  <option value="Personal">Personal</option> -->
                </select>
                <label for="AccntRole" class="profile_label">Account Type</label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountexternid"
                  id="Accntexternid"
                  class="form-control"
                  disabled
                  v-model="form.externid"
                />
                <label for="AccntId" class="profile_label">ID #:</label>
              </div>
              <div
                v-if="isPatient"
                class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0"
              >
                <input
                  type="date"
                  name="accountdob"
                  id="Accntdob"
                  class="form-control"
                  v-model="form.dob"
                />
                <label for="Accntdob" class="profile_label">DOB:</label>
              </div>
            </div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bname"
                  id="businessname"
                  placeholder="Business Name"
                  class="form-control"
                  v-model="businessInfo.name"
                  required
                />
                <label for="businessname" class="profile_label">Business Name:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="EINum"
                  id="einnum"
                  placeholder="EIN Number"
                  class="form-control"
                  v-model="businessInfo.ein"
                  required
                />
                <label for="einnum" class="profile_label">EIN:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="firstname"
                  id="AccntFname"
                  value=""
                  class="form-control"
                  placeholder="Required"
                  v-model="form.first"
                  required
                />
                <label for="AccntFname" class="profile_label">First Name:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="lastname"
                  id="AccntLname"
                  value=""
                  class="form-control"
                  placeholder="Required"
                  v-model="form.last"
                  required
                />
                <label for="AccntLname" class="profile_label">Last Name:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="email"
                  name="accountEmail"
                  id="AccntEmail"
                  placeholder="Account Email"
                  class="form-control"
                  v-model="form.email"
                  @keyup="validateEmail"
                  required
                />
                <label for="AccntEmail" class="profile_label">Account Email:</label>
                <form-error
                  v-if="formErrors.email.length != 0"
                  :errors="formErrors.email"
                />
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="accountUname"
                  id="AccntpUsername"
                  placeholder="Username"
                  class="form-control"
                  v-model="form.login"
                  @keyup="validateUsername"
                  required
                />
                <label for="AccntUsername" class="profile_label">Username:</label>
                <form-error
                  v-if="formErrors.login.length != 0"
                  :errors="formErrors.login"
                />
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="password"
                  name="accountPword"
                  id="AccntPWord"
                  placeholder="Password"
                  class="form-control"
                  v-model="form.password"
                  @change="validatePassword"
                  required
                />
                <form-error :errors="formErrors.password" />
                <label for="AccntPword" class="profile_label">Password:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="password"
                  name="accountPwordConfirm"
                  id="AccntPWordConfirm"
                  placeholder="Confirm Password"
                  class="form-control"
                  v-model="form.password2"
                  @change="confirmPassword"
                  required
                />
                <form-error :errors="formErrors.password2" />
                <label for="AccntPwordConfirm" class="profile_label"
                  >Confirm Password:</label
                >
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="baddress"
                  id="businessaddr"
                  placeholder="Address"
                  class="form-control"
                  v-model="form.addr"
                  required
                />
                <label for="businessaddr" class="profile_label">Address:</label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bcity"
                  id="businessncity"
                  placeholder="City"
                  class="form-control"
                  v-model="form.city"
                  required
                />
                <label for="businesscity" class="profile_label">City:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="form.state"
                  name="personalstate"
                  id="AccntState"
                  class="form-select"
                  required
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="businessstate" class="profile_label">State:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bzip"
                  id="buzip"
                  placeholder="Zip Code"
                  class="form-control"
                  v-model="form.zip"
                  required
                />
                <label for="bzip" class="profile_label">Zip:</label>
              </div>
            </div>
            <div class="row mb-2 gx-2">
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  class="col-12 form-select"
                  required
                  v-model="form.primaryPhoneType"
                >
                  <option v-for="phone in phoneTypes" :key="phone.id" :value="phone.id">
                    {{ phone.type }}
                  </option>
                </select>
                <label class="profile_label">Phone Type</label>
              </div>
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  id="regphone"
                  class="form-control"
                  placeholder="Required"
                  v-model="form.primaryPhone"
                  required
                />
                <label for="mblphone" class="profile_label">Phone Number</label>
              </div>
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <select class="col-12 form-select" required v-model="form.pref">
                  <option value="Email" selected>Email</option>
                  <option value="SMS">SMS</option>
                  <option value="Phone">Phone</option>
                  <option value="All">SMS, Phone & Email</option>
                </select>
                <label for="commpref" class="profile_label"
                  >Communication Preference</label
                >
              </div>
            </div>
            <div class="linedivider col-sm-12 col-md-12 col-lg-12"></div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <p>
                Please Select the package that reflects your organization needs. If you
                need help deciding which plan, you can compare plans
                <a href="#compareplans" title="Compare Plan Details">here</a>.
              </p>
              <select
                name="packplan"
                id="pckgpln"
                placeholder="Select a Package Plan"
                class="form-select"
                v-model="billingInfo.plan"
              >
                <option value="Basic" selected="selected">EMR Basic</option>
                <option value="Essential">EMR Essential</option>
                <option value="Enterprise">EMR Enterprise</option>
              </select>

              <p>
                The Billing Information Below will be used to bill your payment on file.
                You can change your payment preferences in your account settings.
              </p>
            </div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilccName"
                  id="billccName"
                  placeholder="Card Holders Name"
                  class="form-control"
                  v-model="billingInfo.cardHolder"
                  required
                />
                <label for="billccName" class="profile_label">Card Holder Name:</label>
              </div>
              <div class="col-md-6 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilccnumber"
                  id="billccnumber"
                  placeholder="Card Number"
                  class="form-control"
                  v-model="billingInfo.cardNumber"
                  required
                />
                <label for="billccnumber" class="profile_label">Card Number:</label>
              </div>
            </div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-md-4 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="date"
                  name="billexpDt"
                  id="billexpDt"
                  placeholder="Card Expiration Date"
                  class="form-control"
                  v-model="billingInfo.expDate"
                  required
                />
                <label for="billexpDt" class="profile_label">Expiration Date:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilcv3"
                  id="billcv3"
                  placeholder="CVV"
                  class="form-control"
                  v-model="billingInfo.cvv"
                  required
                />
                <label for="billcv3r" class="profile_label">CVV:</label>
              </div>
            </div>
            <div v-if="isBusiness" class="row mb-2 gx-2">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <label for="billingsameaddr">Billing Address Same as Address</label>
                <input
                  type="checkbox"
                  name="billsameaddr"
                  id="billingsameaddr"
                  @change.prevent="PullPersonalAddr()"
                  placeholder="Business Name"
                  class="col-sm-12 col-md-6 col-lg-6 f-field"
                  required
                  v-model="billAddrCheck"
                />
              </div>
              <div class="col-md-5 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="billaddr"
                  id="billaddr"
                  placeholder="Billing Address"
                  class="form-control"
                  v-model="billingInfo.billingAddr"
                  required
                />
                <label for="billAddr" class="profile_label">Billing Address:</label>
              </div>
              <div class="col-md-3 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="bilcity"
                  id="billCity"
                  placeholder="City"
                  class="form-control"
                  v-model="billingInfo.billingCity"
                  required
                />
                <label for="billCity" class="profile_label">Billing City:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <select
                  v-model="billingInfo.billingState"
                  name="billState"
                  id="billState"
                  class="form-select"
                  required
                >
                  <option value="">Select a state</option>
                  <option
                    v-for="(state, index) in states"
                    :key="index"
                    :value="state.abbr"
                  >
                    {{ state.abbr }}
                  </option>
                </select>
                <label for="billState" class="profile_label">Billing State:</label>
              </div>
              <div class="col-md-2 col-12 form-group form-floating mb-2 mb-lg-0">
                <input
                  type="text"
                  name="billzip"
                  id="billzip"
                  placeholder="Billing Zip Code"
                  class="form-control"
                  v-model="billingInfo.billingZip"
                  required
                />
                <label for="billZip" class="profile_label">Billing Zip:</label>
              </div>
            </div>
            <!-- <div class="col-sm-12 col-md-6 col-lg-6">
                <label for="billPhn">Work Phone</label><br />
                <select
                  id="billormblphone"
                  name="billPhone"
                  class="col-sm-12 col-md-6 col-lg-6 f-field"
                >
                  <option selected="selected" value="workphone">Office Phone</option>
                  <option value="Cell">Mobile Phone</option>
                </select>
              </div> -->
            <!--ENdBillling Section-->
            <!-- <div class="workingsign col-sm-12 col-md-12 col-lg-12">
              <p>WORKING - Please be patient.....</p>
            </div> -->
            <div class="col-sm-12 col-md-12 col-lg-12" id="saveformSec">
              <button class="btn btn-primary" type="submit">Create Account</button>
            </div>
            <!-- </div>  -->
            <!--end New FOrm Canvas Here -->
            <!-- <label v-if="!isLoggedIn" class="col-form-label col-md-4" for="admin">Administrator:</label>
            <input v-if="!isLoggedIn" id="admin" type="checkbox" class="col-md-6" v-model="form.admin" />

            <template v-if="form.admin">
              <label class="col-form-label col-md-4" for="npi">NPI: </label>
              <input id="npi" type="number" v-model="form.npi" class="form-control col-md-6" required placeholder="NPI"
                @input="validateNpi">
              <form-error :errors="formErrors.npi" />
            </template>

            <label class="col-form-label col-md-4" for="externid">ID: </label>
            <input id="externid" type="text" v-model="form.externid" class="form-control col-md-6" required
              placeholder="ID" @change="validateId">
            <form-error :errors="formErrors.externid" />


            <label class="col-form-label col-md-4" for="first">First name: </label>
            <input id="first" type="text" v-model="form.first" class="form-control col-md-6" required
              placeholder="First Name" @change="validateName(form.first, FIRST)">
            <form-error :errors="formErrors.first" />

            <label class="col-form-label col-md-4" for="middle">Middle name: </label>
            <input id="middle" type="text" v-model="form.middle" class="form-control col-md-6" placeholder="Middle Name"
              @change="validateName(form.middle, MIDDLE)">
            <form-error :errors="formErrors.middle" />

            <label class="col-form-label col-md-4" for="last">Last name: </label>
            <input id="last" type="text" v-model="form.last" class="form-control col-md-6" required
              placeholder="Last Name" @change="validateName(form.last, LAST)">
            <form-error :errors="formErrors.last" />

            <label class="col-form-label col-md-4" for="login">Username: </label>
            <input id="login" type="text" v-model="form.login" class="form-control col-md-6" required
              placeholder="Enter username" @change="validateUsername">
            <form-error :errors="formErrors.login" />

            <label class="col-form-label col-md-4" for="password">Password: </label>
            <input id="password" v-model="form.password" class="form-control col-md-6" required
              :type="PASSWORD_INPUT_TYPE" placeholder="Enter password" @change="validatePassword">
            <a class="col-form-label col-md-2" @click="togglePasswordType">{{ showHide }}</a>

            <form-error :errors="formErrors.password" />

            <label class="col-form-label col-md-4" for="password2">Confirm password: </label>
            <input id="password2" v-model="form.password2" class="form-control col-md-6" required type="password"
              placeholder="Confirm password" @change="confirmPassword">
            <form-error :errors="formErrors.password2" />

            <label class="col-form-label col-md-4" for="dob">Date of Birth: </label>
            <input id="dob" v-model="form.dob" class="form-control col-md-6" required type="date">
            <form-error :errors="formErrors.dob" />

            <label class="col-form-label col-md-4" for="email">Email: </label>
            <input id="email" v-model="form.email" class="form-control col-md-6" required type="email">
            <form-error :errors="formErrors.email" /> -->

            <!-- TODO: encrypt ssn in backend before uncommenting this  -->
            <!-- <label class="col-form-label col-md-4" for="ssnHead">SSN: </label>
            <input id="ssnHead"
                   v-model="form.ssnHead"
                   class="form-control col-md-2"
                   type="password"
                   v-mask="'###'"
                   @keyup="handleSsnHeadKeyup">
            <input id="ssnMiddle"
                   v-model="form.ssnMiddle"
                   class="form-control col-md-1"
                   type="password"
                   v-mask="'##'"
                   @keyup="handleSsnMiddleKeyup">
            <input id="ssnTail"
                   v-model="form.ssnTail"
                   class="form-control col-md-3"
                   type="text"
                   v-mask="'####'">
            <form-error :errors="formErrors.ssn"/> -->

            <!-- <label class="col-form-label col-md-4" for="gender">Gender: </label>
            <select id="gender" v-model="form.gender" required class="form-control col-md-6">
              <option v-for="(gender, index) in genders" :key="'gender-' + index" :value="gender.id">{{ gender.value }}
              </option>
            </select>
            <form-error :errors="formErrors.gender" />

            <label class="col-form-label col-md-4" for="suffix">Suffix: </label> 
            <select id="suffix" v-model="form.suffix" class="form-control col-md-6">-->
            <!-- @change="validateAffix(AFFIX.SUFFIX)" -->
            <!-- <option v-for="(suffix, index) in suffixes" :key="'suffix-' + index" :value="suffix.id">
                {{ suffix.value }}
              </option>
            </select>
            <form-error :errors="formErrors.suffix" />

            <label class="col-form-label col-md-4" for="title">Title: </label>
            <select id="title" v-model="form.title" class="form-control col-md-6"> -->
            <!-- @change="validateAffix(AFFIX.TITLE)" -->
            <!--  <option v-for="(title, index) in titles" :key="'title-' + index" :value="title.id">
                {{ title.value }}
              </option>
            </select>
            <form-error :errors="formErrors.title" />

            <label class="col-form-label col-md-4" for="addr">Address: </label>
            <input id="addr" v-model="form.addr" class="form-control col-md-6" type="text" @change="validateAddr">
            <form-error :errors="formErrors.addr" />

            <label class="col-form-label col-md-4" for="city">City: </label>
            <input id="city" v-model="form.city" class="form-control col-md-6" type="text" />
            <form-error :errors="formErrors.city" />

            <label class="col-form-label col-md-4" for="state">State: </label>
            <select id="state" v-model="form.state" class="form-control col-md-6">
              <option v-for="(state, index) in states" :key="index" :value="state.abbr">{{ state.abbr }}</option>
            </select>
            <form-error :errors="formErrors.state" />

            <label class="col-form-label col-md-4" for="zip">Zip: </label>
            <input id="zip" v-model="form.zip" class="form-control col-md-6" type="text" v-mask="'#####'" />
            <form-error :errors="formErrors.zip" />

            <label class="col-form-label col-md-4" for="cell">Cell: </label>
            <input id="cell" v-model="cell" class="form-control col-md-6" type="tel" v-mask="'+1 (###) ###-####'" />
            <form-error :errors="formErrors.cell" />

            <label class="col-form-label col-md-4" for="work">Work: </label>
            <input id="work" v-model="work" class="form-control col-md-6" type="tel" v-mask="'+1 (###) ###-####'" />
            <form-error :errors="formErrors.work" />

            <label class="col-form-label col-md-4" for="home">Home: </label>
            <input id="home" v-model="home" class="form-control col-md-6" type="tel" v-mask="'+1 (###) ###-####'" />
            <form-error :errors="formErrors.home" />

            <label class="col-form-label col-md-4" for="home">SSN (last 4): </label>
            <input id="ssn" v-model="ssn" class="form-control col-md-6" type="text" />
            <form-error :errors="formErrors.ssn" />-->
          </div>
          <div class="button-group">
            <!-- <button type="submit" class="col-md-12 col-12 btn btn--login">Register</button> -->
            <!-- <a href="#" class="form__link">How do I get an enrollment ID?</a> -->
            <router-link to="/login" class="form__link">Return to log in</router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import router from "@/router/index";
import { register, isUserExist, isEmailExist } from "@/api/userApi";
import { post } from "@/store/modules/fsm/index";
import us from "us";
import {
  RequestRegistration,
  RegistrationSuccess,
  RegistrationFailure,
  Continue,
} from "@/store/modules/fsm/messages";
import FormError from "./FormError";
import { mask } from "vue-the-mask";
import { CURR_API, OTHER_API } from "@/constants/apis";
import $ from "jquery";
import axios from "axios";
import VALIDATION_ERRORS from "@/data/validationErrors";
import genders from "@/data/genders";
import titles from "@/data/titles";
import suffixes from "@/data/suffixes";
import { isNpiExist } from "../../../api/userApi";

export default {
  name: "RegisterPage",
  components: {
    "form-error": FormError,
  },
  directives: {
    mask,
  },
  data() {
    return {
      states: us.states,
      genders,
      titles,
      suffixes,
      phoneTypes: [
        { id: 1, type: "CELL" },
        { id: 2, type: "HOME" },
        { id: 3, type: "WORK" },
      ],
      billAddrCheck: false,
      businessInfo: {
        name: "",
        ein: "",
      },
      form: {
        isLoggedIn: false,
        noValidation: false,
        admin: false,
        accountType: "",
        npi: "",
        externid: "",
        externid2: "",
        first: "",
        last: "",
        login: "",
        password: "",
        password2: "",
        enrollmentId: null,
        dob: "1970-01-01",
        email: "",
        gender: 1,
        addr: "",
        city: "",
        state: "",
        zip: "",
        primaryPhoneType: null,
        primaryPhone: null,
        ssn: "",
        pref: "Email",
      },
      billingInfo: {
        plan: "Basic",
        cardHolder: "",
        cardNumber: "",
        expDate: "",
        cvv: "",
        billingAddr: "",
        billingCity: "",
        billingState: "",
        billingZip: "",
      },
      nwform: {},
      regPromise: {},
      cell: null,
      work: null,
      home: null,
      formErrors: {},
      showPassword: false,
    };
  },
  computed: {
    ...mapGetters("login", {
      allData: "getAllData",
      isLoggedIn: "isLoggedIn",
    }),
    ssn() {
      return this.form.ssnHead + this.form.ssnMiddle + this.form.ssnTail;
    },
    PASSWORD_INPUT_TYPE() {
      // TODO: when input field is text, browser may remember
      //       input and provide auto complete
      //       need to disable this feature of browser!
      return this.showPassword ? "text" : "password";
    },
    /**
     * Toggles the show and hide lable for the password field
     */
    showHide() {
      return !this.showPassword ? "Show" : "Hide";
    },
    isBusiness: function () {
      return this.form.accountType === "Business";
    },
    isPatient() {
      return this.form.accountType === "Patient";
    },
  },
  watch: {
    cell(newVal, oldVal) {
      // remove +1, spaces, (, ), and - to extract numbers
      this.form.cell = this.extractPhoneNumber(newVal);
    },
    work(newVal, oldVal) {
      // remove +1, spaces, (, ), and - to extract numbers
      this.form.work = this.extractPhoneNumber(newVal);
    },
    home(newVal, oldVal) {
      // remove +1, spaces, (, ), and - to extract numbers
      this.form.home = this.extractPhoneNumber(newVal);
    },
  },
  created() {
    // initialize errors
    for (let key in this.form) {
      this.$set(this.formErrors, key, []);
    }
    this.form.externid = Math.floor(Math.random() * 899999999) + 100000000;
  },
  methods: {
    validateEmail() {
      let error = null;
      isEmailExist(this.form.email)
        .then((exists) => {
          if (exists) {
            error = VALIDATION_ERRORS.EMAIL_EXISTS;
            this.$set(this.formErrors.email, this.formErrors.email.length, error);
          } else {
            this.formErrors.email = [];
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    PullPersonalAddr() {
      if (this.billAddrCheck) {
        this.billingInfo.billingAddr = this.form.addr;
        this.billingInfo.billingCity = this.form.city;
        this.billingInfo.billingState = this.form.state;
        this.billingInfo.billingZip = this.form.zip;
      }
    },
    CreatePatient() {
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = this.$loading.show(
        {},
        {
          after: this.$createElement("div", {}, ["Registering your information..."]),
        }
      );
      post({ message: RequestRegistration })
        .then(() => {
          this.form.isLoggedIn = this.isLoggedIn;
          this.form.admin = false;
          this.form.externid2 = this.allData.patient.externId2;
          return register(this.form);
        })
        .then((res) => {
          console.log(res);
          alert(`Registration successful. The username is ${this.form.login}.`);
          post({ message: RegistrationSuccess });
        })
        .catch((err) => {
          post({ message: RegistrationFailure });
          alert("Registration failure: " + err);
        })
        .finally(() => {
          loader.hide();
          loader = null;
        });
    },
    async CreateNewAccount() {
      if (this.isPatient) {
        this.CreatePatient();
        return;
      }
      if (!this.validate()) {
        this.$swal({
          type: "warning",
          title: "Error",
          text: "Please fix the errors in the form to finish registering this account.",
        });
        return;
      }
      let loader = this.$loading.show(
        {
          container: this.$refs.pageBody,
        },
        {
          after: this.$createElement("div", {}, [`Creating account...`]),
        }
      );
      this.nwform.accountnumber = Math.floor(Math.random() * 899999999) + 100000000;
      this.nwform.orgname = this.businessInfo.name;
      this.nwform.einnum = this.businessInfo.ein;
      this.nwform.accountrole = this.form.accountType;
      this.nwform.accountcontact = this.form.first + " " + this.form.last;
      this.nwform.Firstname = this.form.first;
      this.nwform.Lastname = this.form.last;
      this.nwform.prAddress = this.form.addr;
      this.nwform.prCity = this.form.city;
      this.nwform.prState = this.form.state;
      this.nwform.prZip = this.form.zip;
      this.nwform.username = this.form.login;
      this.nwform.password = this.form.password;
      this.nwform.email = this.form.email;
      this.nwform.cell = this.form.primaryPhone;
      this.nwform.companyaddress = this.form.addr;
      this.nwform.companycity = this.form.city;
      this.nwform.companystate = this.form.state;
      this.nwform.companyzip = this.form.zip;
      //billing Addresss Information
      this.nwform.billAddr = this.billingInfo.billingAddr;
      this.nwform.billCity = this.billingInfo.billingCity;
      this.nwform.billState = this.billingInfo.billingState;
      this.nwform.billZip = this.billingInfo.billingZip;
      this.nwform.companyphone = this.form.primaryPhone;
      this.nwform.cardholdername = this.billingInfo.cardHolder;
      this.nwform.cardnumber = this.billingInfo.cardNumber;
      this.nwform.cardexpDt = this.billingInfo.expDate;
      this.nwform.cardcvv3 = this.billingInfo.cvv;
      this.nwform.packageLevel = this.billingInfo.plan;
      this.nwform.npi = ""; //do't think we need this actually and can be stransfered to acount_user table
      this.nwform.license = ""; //might not actually ned this as well
      this.nwform.emrUserLicense = Math.floor(Math.random() * 89999999);
      this.nwform.licenseState = "Active";
      this.nwform.licenseStrtDate = new Date().toJSON().slice(0, 10).replace(/-/g, "-");
      this.nwform.licenseEndDt = "2026-12-01";
      this.nwform.licenseCost = "900.00";
      this.nwform.accounttype = this.form.accountType;
      this.nwform.secreteQuestion = "";
      this.nwform.terms = "Yes";

      //lets fill in the Form Object in Order to get a Unique Nine that's been assigned from the backend
      //this.form.data={};
      // this.form.externid="755717554";
      this.form.isLoggedIn = this.isLoggedIn;
      this.form.externid2 = this.nwform.accountnumber;
      if (this.isBusiness) {
        this.form.admin = true;
      }

      register(this.form)
        .then((data) => {
          if (data.externid && data.externid != "") {
            this.nwform.uniqueNineID = data.externid;
            this.SendAccountInfo().then((x) => {
              console.log(x);
              loader.hide();
              this.$swal({
                type: "success",
                title: "Success",
                text:
                  "This account has been created. You will now be redirected to the login page.",
              }).then((result) => {
                router.push({ name: LoginNavigation });
              });
            });
          } else {
            alert("Something wrong with register function");
            console.log(data);
            loader.hide();
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Caught exception for register function");
          loader.hide();
        });
    },
    async SendAccountInfo() {
      let msg = "";
      let ermsg = "";
      //check to see if the required settings has a value
      /* if($("#AccntFname").val() !="" && $("#AccntLname").val() && $("#AccntEmail").val() !="" && $("#AccntpUsername").val() !="" && $("#AccntPWord").val() !=""
            && $("#businessname").val() !="" && $("#einnum").val() !="",$("#billccnumber").val() !="" && $("#billexpDt").val() !=""
             && $("#billaddr").val() !="" && $("#billCity").val() !="" && $("#billZip").val() !="" && $("#pckgpln").val() !="")
            {*/

      //now lets send over values to be saved on the serv er
      let content = {
        Account: {
          API_Meth: "CreateAccount",
          Formdata: this.nwform,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.data.message == "Account Created Successfully") {
            alert("Account Created successfully");
            msg = "Account Created";
            return msg;
          } else {
            //I would process error from the API here that are inline with the Account Setup on the backend
            console.log(res.data);
            alert("Account Not Created Successfully");
            msg = "Account Not Created";
            return msg;
          }
        })
        .catch((res) => {
          let jdata = JSON.parse(res);
          alert(jdata); //spit out the error
          alert("Error" + " " + res.data);
          console.log("Error" + " " + jdata);
          msg = "Error with the Promise";
          return msg;
        });
      /* }
            else{
                alert("Please ensure the required fields have values before you can create an account.");
               msg ="Account Not Created";
                return msg;
            }*/
    },
    randomId() {
      return Math.floor(Math.random() * 899999999) + 100000000;
    },
    extractPhoneNumber(num) {
      const regex = /(\+1)|\s|\(|\)|\-/g;
      return num.replace(regex, "");
    },
    checkIfUserValid() {
      if (!this.form.login || this.form.login.length > 24 || this.form.login.length < 8) {
        this.isUserExist_symbol = "X";
        return;
      }
      isUserExist(this.form.login)
        .then(() => {
          this.isUserExist_symbol = "O";
        })
        .catch((err) => {
          this.isUserExist_symbol = "X";
        });
    },
    togglePasswordType() {
      this.showPassword = !this.showPassword;
    },
    /**
     * moves focus to next input field
     */
    handleSsnHeadKeyup() {
      if (this.form.ssnHead.length === 3) {
        document.getElementById("ssnMiddle").focus();
      }
    },
    /**
     * moves focus to next input field
     */
    handleSsnMiddleKeyup() {
      if (this.form.ssnMiddle.length === 2) {
        document.getElementById("ssnTail").focus();
      }
    },
    validateSsn() {
      this.formErrors.ssn = [];
      let ssn = this.form.ssn.trim();
      if (ssn.length != 0 || ssn.length != 4 || !/^\d+$/.test(ssn)) {
        this.$set(
          this.formErrors.ssn,
          this.formErrors.ssn.length,
          VALIDATION_ERRORS.INVALID_SSN
        );
      }
    },
    validateId() {
      this.formErrors.externid = [];
      let id = this.form.externid.trim();
      if (id.length != 9 || !/^\d+$/.test(id)) {
        this.$set(
          this.formErrors.externid,
          this.formErrors.externid.length,
          VALIDATION_ERRORS.INVALID_ID
        );
      }
    },
    /**
     * @param string nameType first, middle, or last
     */
    validateName(name, nameType) {
      //TODO: only letters are allowed at the moment
      const nameRegex = new RegExp("^([a-zA-Z])+([ a-zA-Z])*$");
      let error = null;

      this.form[nameType] = this.form[nameType].trim();
      this.formErrors[nameType] = [];
      if (this.form[nameType] !== "" && !nameRegex.test(this.form[nameType])) {
        error = VALIDATION_ERRORS.LETTERS_ONLY;
        this.$set(this.formErrors[nameType], this.formErrors[nameType].length, error);
      }
    },
    validateUsername() {
      const usernameRegex = new RegExp("^([a-zA-Z]|_)+([a-zA-Z0-9_])*$");
      let error = null;

      this.form.login = this.form.login.trim();
      this.formErrors.login = [];
      //TODO: send ajax to check if username exist?
      if (!usernameRegex.test(this.form.login)) {
        error = VALIDATION_ERRORS.USERNAME_CHARACTERS;
        this.$set(this.formErrors.login, this.formErrors.login.length, error);
      }
      if (this.form.login.length < 8 || this.form.login.length > 24) {
        error = VALIDATION_ERRORS.USERNAME_LENGTH;
        this.$set(this.formErrors.login, this.formErrors.login.length, error);
      }
      if (this.formErrors.login.length < 1) {
        isUserExist(this.form.login)
          .then((userExists) => {
            if (userExists) {
              error = VALIDATION_ERRORS.USERNAME_EXISTS;
              this.$set(this.formErrors.login, this.formErrors.login.length, error);
            }
          })
          .catch((err) => {
            alert(err);
          });
      }
      return true;
    },
    validateNpi() {
      let error = null;
      this.form.npi = this.form.npi.trim();
      this.formErrors.npi = [];

      isNpiExist(this.form.npi)
        .then((npiExists) => {
          if (npiExists) {
            console.log(npiExists);
            error = VALIDATION_ERRORS.NPI_EXISTS;
            this.$set(this.formErrors.npi, this.formErrors.npi.length, error);
          }
        })
        .catch((err) => {
          alert(err);
        });
    },
    validatePassword() {
      const strongRegex = new RegExp(
        `^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[~!@#\$%\^&\*\(\)\-\+,\.\?\/;:\'\"\[\]\{\}\|\\])(?=.{12,})`
      );
      const mediumRegex = new RegExp(
        "^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{8,})"
      );

      //FIXME: use a better regex
      const passwordRegex = new RegExp(`^[a-zA-Z0-9,\.\?~!@#\$%\^&\*_]+$`);

      let error = null;
      this.formErrors.password = [];

      if (!passwordRegex.test(this.form.password)) {
        error = VALIDATION_ERRORS.PASSWORD_CHARACTERS;
        this.$set(this.formErrors.password, this.formErrors.password.length, error);
      }
      if (!(this.form.password.length >= 12 && this.form.password.length <= 24)) {
        error = VALIDATION_ERRORS.PASSWORD_LENGTH;
        this.$set(this.formErrors.password, this.formErrors.password.length, error);
      }

      if (this.form.password2 && this.form.password2 !== "") {
        this.confirmPassword();
      }
    },
    confirmPassword() {
      this.formErrors.password2 = [];
      if (this.form.password !== this.form.password2) {
        this.formErrors.password2.push(VALIDATION_ERRORS.PASSWORD_MISMATCH);
      }
    },
    validateAffix(affixType) {
      const affixRegex = new RegExp("^[a-zA-Z]+[\\s\.a-zA-Z]*$");
      let error = null;

      this.form[affixType] = this.form[affixType].trim();
      this.formErrors[affixType] = [];
      if (this.form[affixType] !== "" && !affixRegex.test(this.form[affixType])) {
        error = VALIDATION_ERRORS.NO_SPECIAL_CHARACTERS_OR_NUMBERS;
        this.$set(this.formErrors[affixType], this.formErrors[affixType].length, error);
      }
    },
    validateAddr() {
      const addrRegex = new RegExp("^[ 0-9a-zA-Z]+[ \.\-0-9a-zA-Z]*$");
      let error = null;

      this.form.addr = this.form.addr.trim();
      this.formErrors.addr = [];
      if (this.form.addr !== "" && !addrRegex.test(this.form.addr)) {
        error = VALIDATION_ERRORS.NO_SPECIAL_CHARACTERS;
        this.$set(this.formErrors.addr, this.formErrors.addr.length, error);
      }
    },
    validatePhoneNumber(phoneNumberType) {
      //TODO: add and verify
      const phoneNumberRegex = new RegExp("^[0-9]{9}|[0-9]{10}$");
      let error = null;

      this.formErrors[phoneNumberType] = [];
      if (
        this.form[phoneNumberType] &&
        !phoneNumberRegex.test(this.form[phoneNumberType])
      ) {
        error = VALIDATION_ERRORS.INVALID_PHONE_NUMBER;
        this.$set(
          this.formErrors[phoneNumberType],
          this.formErrors[phoneNumberType].length,
          error
        );
      }
    },

    /**
     * validates text field (no explicit check for length)
     */
    validateTextField(filed, regex, errMsg) {
      this.form[field] = this.form[field].trim();
      this.formErrors[filed] = [];
      if (this.form[field] !== "" && !regex.test(this.form[filed])) {
        this.$set(this.formErrors[field], this.formErrors[field].length, errMsg);
      }
    },

    validate() {
      for (let key in this.formErrors) {
        if (this.formErrors[key] && this.formErrors[key].length > 0) {
          return false;
        }
      }
      return true;
    },
    capitalizeWords(words) {
      words = words.tolower().split(" ");
    },
    toTitleCase(str) {
      str = str.toLowerCase().split(" ");
      for (let i = 0; i < str.length; i++) {
        str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
      }

      return str.join(" ");
    },
    removeExcessiveSpaces(str) {
      return str.trim().replace(/\s+/g, " ");
    },
    sanitizeForm() {
      for (let field in this.form) {
        if ("string" === typeof this.form[field]) {
          this.form[field] = this.removeExcessiveSpaces(this.form[field]);
          if (
            "first" === field ||
            "middle" === field ||
            "last" === field ||
            "addr" === field ||
            "city" === field
          ) {
            this.form[field] = this.toTitleCase(this.form[field]);
          }
        }
      }
      this.form.externid = parseInt(this.form.externid);
    },
    // handleRegistration() {
    //   if (!this.validate()) {
    //     alert("Please correct the errors in the form before submitting.");
    //     return;
    //   }

    //   let loader = this.$loading.show(
    //     {},
    //     {
    //       after: this.$createElement("div", {}, ["Registering your information..."]),
    //     }
    //   );

    //   // sanitize input before submitting
    //   this.sanitizeForm();

    //   post({ message: RequestRegistration })
    //     .then(() => {
    //       this.form.isLoggedIn = this.isLoggedIn;
    //       return register(this.form);
    //     })
    //     .then((username) => {
    //       if (this.isLoggedIn)
    //         alert(`Registration success. The username is: "${username}".`);
    //       else
    //         alert(
    //           `Registration success. Your username is: "${username}". Please find your verification code in your email.`
    //         );
    //       //TODO: redirect to verification page instead
    //       post({ message: RegistrationSuccess });
    //     })
    //     .catch((err) => {
    //       post({ message: RegistrationFailure });
    //       alert("Registration failure: " + err);
    //     })
    //     .finally(() => {
    //       loader.hide();
    //       loader = null;
    //     });
    // },
  },
};
</script>

<style scoped lang="scss">
@import "../../../stylesheets/mixins/alignment";

$color-base: #0060ff;

.content {
  width: 100%;
  height: auto;
  background: url("../../../assets/images/bg.jpg") no-repeat center fixed; // TODO image subject to copyright
  background-size: cover;
  position: relative;
}

.login-wrapper {
  height: 100vh;
  width: 900px; //500px;
  margin: 0 auto;
  position: relative;
  overflow: scroll;
}
.new-accountForm {
  display: flex;
  flex-direction: column;
}
#AccntSection {
  display: flex;
  flex-wrap: wrap;
}
#AccntSection input[type="text"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#AccntSection input[type="email"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#AccntSection input[type="password"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#AccntSection select {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#BusinessSec {
  display: flex;
  flex-direction: column;
}
.businessFormField {
  display: flex;
  flex-wrap: wrap;
}
.businessFormField input[type="text"] {
  width: 320px;
  height: 42px;
  border-radius: 2px;
}
#billingInfosec {
  display: flex;
  flex-wrap: wrap;
}
#billingInfosec label {
  font-size: 16px;
}
#billingInfosec input[type="text"] {
  width: 420px;
  height: 42px;
  border-radius: 2px;
  border-color: #003330;
}
#billingInfosec input[type="date"] {
  width: 420px;
  height: 42px;
  border-radius: 2px;
  border-color: #003330;
}
#billingInfosec select {
  width: 420px;
  height: 42px;
  border-radius: 2px;
  border-color: #003330;
}
#billingInfosec #billaddr {
  width: 420px;
}
#billingInfosec #billCity {
  width: 420px;
}
#billingInfosec #billState {
  width: 420px;
}
#billingInfosec #billormblphone {
  width: 420px;
}
.linedivider {
  width: 100%;
  border-width: 1px;
  border-style: dashed;
  margin: 10px 0px;
}
#saveformSec {
  margin-top: 20px;
}
.accntl-msg #formMsg {
  border-style: solid;
  border-color: #003330;
  padding: 40px;
  border-radius: 9px;
  display: none;
}
.formmsg .validation {
  font-family: serif, sans-serif;
  font-style: italic;
  font-weight: 600;
  color: #ff0000;
}
.workingsign {
  display: none;
  background-color: #000000;
  height: 120px;
  padding-top: 30px;
}
.workingsign p {
  font-size: 18px;
  color: #ffffff;
  font-family: sans-serif;
}
.login {
  height: inherit;
  background-color: #fff;
  padding: 2em;
  -moz-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.12),
    0 1px 5px 0 rgba(0, 0, 0, 0.2);
  // @include absoluteCenter(500px);
}

.btn--login {
  color: #fff;
  background-color: $color-base;

  &:hover {
    background-color: lighten($color-base, 5%);
  }
}

.button-group {
  /*margin-top: 1.5rem;*/

  .form__link {
    color: $color-base;
    font-size: 0.85rem;
    margin-top: 0.5rem;
    display: block;

    &:hover {
      text-decoration: underline;
    }
  }
}

label,
input {
  font-size: 12px;
  margin-bottom: 10px;
}

input:not([type="checkbox"]) {
  font-size: 14px;
}

input[type="checkbox"] {
  font-size: 4px;
}

@media only screen and (max-width: 768px) {
  .login {
    width: 100%;
  }
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
